




import Vue from 'vue'

/* Modified from https://github.com/Frill-co/frill-widget-examples/tree/master/vue */
export default Vue.extend({
  name: 'FrillWidget',

  data() {
    return {
      widget: undefined as any | undefined,
      config: undefined as any | undefined,
    }
  },
  mounted() {
    if (!this.$screen.isMobile(this.$mq)) {
      this.setupFrillWidget()
    }
  },
  beforeDestroy() {
    if (this.widget) {
      this.widget.destroy()
      this.widget = undefined
    }
    if (this.config) {
      // @ts-ignore
      window.Frill_Config = window.Frill_Config.filter(c => c !== this.config)
    }
  },
  methods: {
    setupFrillWidget() {
      this.config = {
        key: '02340907-3e4a-4b59-8a2b-25088bf1489f', // <-- Add Widget key here
        callbacks: {
          // @ts-ignore
          onReady: frillWidget => {
            this.widget = frillWidget
          },
        },
      }
      // @ts-ignore
      window.Frill_Config = window.Frill_Config || []
      // @ts-ignore
      window.Frill_Config.push(this.config)
      if ('Frill' in window) {
        // @ts-ignore
        this.widget = window.Frill.widget(this.config)
      }
    },
  },
})
